import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { IcReceipt, FaIcon } from "../../Icons";

function BotonesFiscal() {
  const { user } = useContext(AuthContext);

  const ITEMS = [
    {
      label:   "Facturas",
      icon:    "fas fa-file-invoice-dollar",
      color:   "#3b82f6",
      bg:      "#eff6ff",
      href:    "/ListadoFacturas",
      desc:    "Emisión y listado de facturas",
      enabled: !!user.facturasFiscal,
    },
    {
      label:   "Complementos de Pago",
      icon:    "fas fa-money-bill-wave",
      color:   "#10b981",
      bg:      "#f0fdf4",
      href:    "/ListadoComplementosPago",
      desc:    "Complementos de pago emitidos",
      enabled: !!user.compPagosFiscal,
    },
    {
      label:   "Pagos a Facturas",
      icon:    "fas fa-receipt",
      color:   "#f59e0b",
      bg:      "#fffbeb",
      href:    "/ListadoPagosFacturas",
      desc:    "Facturas con pago registrado",
      enabled: !!user.compPagosFiscal,
    },
    {
      label:   "Notas de Crédito",
      icon:    "fas fa-money-check-alt",
      color:   "#6366f1",
      bg:      "#eef2ff",
      href:    "/ListadoNotasCredito",
      desc:    "Notas de crédito generadas",
      enabled: !!user.notasCreditoFiscal,
    },
    {
      label:   "Registrar FIEL",
      icon:    "fas fa-building",
      color:   "#8b5cf6",
      bg:      "#f5f3ff",
      href:    "/RegistrarEmpresas",
      desc:    "Alta de certificados FIEL",
      enabled: !!user.menu_fiscal,
    },
    {
      label:   "Empresas",
      icon:    "fas fa-city",
      color:   "#64748b",
      bg:      "#f8fafc",
      href:    "/ListadoEmpresas",
      desc:    "Empresas registradas",
      enabled: !!user.menu_fiscal,
    },
  ];

  return (
    <>
      <Header />
      <div className="card container col-12" style={{ padding: "20px 24px" }}>

        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 24 }}>
          <div style={{
            width: 36, height: 36, borderRadius: 8, background: "#eff6ff",
            display: "flex", alignItems: "center", justifyContent: "center",
            border: "1px solid #bfdbfe",
          }}>
            <IcReceipt style={{ color: "#3b82f6" }} />
          </div>
          <div>
            <h3 style={{ margin: 0, fontSize: "1rem", fontWeight: 700, color: "#0f172a" }}>
              Fiscal
            </h3>
            <p style={{ margin: 0, fontSize: "0.75rem", color: "#64748b" }}>
              Facturación, complementos y notas de crédito
            </p>
          </div>
        </div>

        {user.menu_fiscal ? (
          <div className="row">
            {ITEMS.map((r, i) => (
              <div key={i} className="col-6 col-md-4 col-xl-3 mb-3">
                <a
                  href={r.enabled ? r.href : undefined}
                  style={{
                    display:        "flex",
                    flexDirection:  "column",
                    alignItems:     "center",
                    gap:            10,
                    padding:        "22px 14px",
                    background:     "#fff",
                    borderRadius:   10,
                    boxShadow:      "0 1px 3px rgba(0,0,0,0.07)",
                    border:         "1px solid #f1f5f9",
                    textDecoration: "none",
                    color:          "#334155",
                    transition:     "box-shadow 0.15s, transform 0.15s",
                    textAlign:      "center",
                    opacity:        r.enabled ? 1 : 0.45,
                    pointerEvents:  r.enabled ? "auto" : "none",
                    cursor:         r.enabled ? "pointer" : "default",
                  }}
                  onMouseEnter={(e) => {
                    if (!r.enabled) return;
                    e.currentTarget.style.boxShadow = "0 6px 20px rgba(0,0,0,0.1)";
                    e.currentTarget.style.transform = "translateY(-2px)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.07)";
                    e.currentTarget.style.transform = "translateY(0)";
                  }}
                >
                  <div style={{
                    width: 52, height: 52, borderRadius: 12,
                    background: r.bg,
                    display: "flex", alignItems: "center", justifyContent: "center",
                  }}>
                    <FaIcon cls={r.icon} size={22} style={{ color: r.color }} />
                  </div>
                  <div>
                    <div style={{ fontWeight: 600, fontSize: "0.82rem", marginBottom: 2 }}>{r.label}</div>
                    <div style={{ fontSize: "0.7rem", color: "#94a3b8", lineHeight: 1.3 }}>{r.desc}</div>
                  </div>
                </a>
              </div>
            ))}
          </div>
        ) : (
          <p style={{ color: "#94a3b8", fontSize: "0.82rem" }}>Sin acceso fiscal.</p>
        )}
      </div>
    </>
  );
}

export default BotonesFiscal;
